export const enum PhotoLayout {
  List = "list",
  Grid = "grid",
}
